// A short two-note chime played when the dashboard appears after login, built with Web Audio.
export function playLoginChime() {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();

    // Some browsers suspend the context until a gesture; the user just clicked Sign In, so resume() usually works.
    if (ctx.state === 'suspended' && ctx.resume) {
      ctx.resume().catch(() => {});
    }

    const now = ctx.currentTime;
    const playNote = (freq, start, duration, peakGain = 0.16) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(peakGain, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + duration + 0.05);
    };

    // C5 → G5 ascending fifth — short, bright, positive
    playNote(523.25, 0.00, 0.32, 0.15);
    playNote(783.99, 0.10, 0.55, 0.18);

    // Close after the sound fully decays so we don't leak audio nodes
    setTimeout(() => ctx.close && ctx.close().catch(() => {}), 1100);
  } catch (_) {
    // audio blocked or unsupported — silently ignore
  }
}
